import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECookiesActionTypes {
  CookiesAccepted = 'cookies/cookiesAccepted',
  SetHideOnboardingByCookie = 'cookies/setHideOnboarding',
}

export type TCookiesAccepted = ITypedReduxAction<ECookiesActionTypes.CookiesAccepted>;
export type TSetHideOnboardingByCookie = ITypedReduxAction<ECookiesActionTypes.SetHideOnboardingByCookie>;

export type TCookiesActions = TCookiesAccepted | TSetHideOnboardingByCookie;
